import { render, staticRenderFns } from "./TicChatPdf.vue?vue&type=template&id=b841eee8&scoped=true&"
import script from "./TicChatPdf.vue?vue&type=script&lang=js&"
export * from "./TicChatPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b841eee8",
  null
  
)

export default component.exports